import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const StatusConfirmModal = ({
  statusRow,
  togglingStatus,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      show={Boolean(statusRow)}
      onHide={() => !togglingStatus && onClose()}
      centered
    >
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h5 mb-0 fw-bold">
          {statusRow?.bitStatus
            ? "Deactivate configuration?"
            : "Enable configuration?"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="py-3">
        {statusRow?.bitStatus ? (
          <p className="mb-0">
            This will deactivate the breakfast configuration for{" "}
            <strong>{statusRow?.propertyName}</strong> (
            <strong>{statusRow?.roomType}</strong>).
          </p>
        ) : (
          <p className="mb-0">
            This will enable this breakfast configuration (
            <strong>
              ₹{Number(statusRow?.BreakfastCharge || 0).toFixed(2)}
            </strong>
            ) for <strong>{statusRow?.propertyName}</strong> (
            <strong>{statusRow?.roomType}</strong>). Any previously active rate
            for this room type will be automatically disabled.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer className="bg-light border-top">
        <Button
          variant="secondary"
          disabled={togglingStatus}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant={statusRow?.bitStatus ? "danger" : "success"}
          disabled={togglingStatus}
          onClick={onConfirm}
          className="px-3 fw-semibold"
        >
          {togglingStatus && (
            <Spinner animation="border" size="sm" className="me-2" />
          )}
          {statusRow?.bitStatus ? "Deactivate" : "Enable"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusConfirmModal;
